import { put, takeLatest } from 'redux-saga/effects';
import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import questionServices from './services';
import questionActions from './actions';
import questionTypes from './types';

function* getQuestionsList(action) {
	try {
		let response = yield sagaCallService(
			questionServices.list,
			action,
			action.payload
		);
		yield put(questionActions.List_Success(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, questionActions.List_Failure);
	}
}

function* replyToQuestion(action) {
	try {
		let response = yield sagaCallService(
			questionServices.reply,
			action,
			action.payload
		);
		yield put(questionActions.Reply_Success(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, questionActions.Reply_Failure);
	}
}

const questionSagas = [
	takeLatest(questionTypes.LIST.REQUEST, getQuestionsList),
	takeLatest(questionTypes.REPLY.REQUEST, replyToQuestion),
];

export default questionSagas;
